import '@/styles/style.scss';
import '@/pages/registration/registration.scss';
import '@/components/template/template.js';
import '@/components/sign-up/sign-up.js';